import React, {FC, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import FetchAudio from '../components/UI/FetchAudio';
import Message from '../components/UI/Message';
import {setSuccess} from '../store/actions/authActions';
import {RootState} from '../store';

const Dashboard: FC = () => {
    const {needVerification, success} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        if (success) {
            dispatch(setSuccess(''));
        }
    }, [success, dispatch]);

    return (
        <>
            {
                needVerification &&
                <section className="section">
                    <div className="container">
                        <Message type="success" msg="Please verify your email address."/>
                    </div>
                </section>
            }
            <FetchAudio/>
        </>
    );
}

export default Dashboard;
